export enum Race {
    'American Indian/Alaskan Native',
    'Asian/Asian American',
    'Black/African American',
    'Native Hawaiian/Pacific Islander',
    White,
    Other,
}
